import React from 'react';
import PropTypes from 'prop-types';
import { Image as BootstrapImg } from 'react-bootstrap';
import useImage from '../../hooks/useImage';

const Image = ({ url, name, department, delayLoadImage, isWithinModal }) => {
	const { imgCls, imgProps } = useImage({
		url,
		name,
		department,
		delayLoadImage,
		isWithinModal
	});

	return (
		<>
			<BootstrapImg className={imgCls} {...imgProps} />
		</>
	);
};

Image.propTypes = {
	name: PropTypes.string.isRequired,
	url: PropTypes.string,
	department: PropTypes.string.isRequired,
	delayLoadImage: PropTypes.bool.isRequired,
	isWithinModal: PropTypes.bool
};

export default Image;
